import React from 'react';
import { Tooltip } from 'antd';
import ImpactedDeviceIco from '@icons/aiAlerts/impacted-device.svg';
import { TOOLTIP_LABEL_IMPACTED_UNIQUE } from '@utils/constants';
import {
  RowWrapper,
  LeftDiv,
  RightDiv,
  CauseText,
  SubText,
  CauseWrap,
  SubMetricText,
  SubImpactedText,
} from './styled';
import {
  formatName,
  formatRootCause,
  formatRootCauseValue,
  formatSessions,
  formatImpactedUnique,
} from './formatter';

function Row({ data, openSummary }) {
  const { dimension, metrics, rootcause } = data;

  const handleClick = () => {
    openSummary(data);
  };

  return (
    <RowWrapper>
      <LeftDiv>
        <CauseWrap onClick={handleClick}>
          <CauseText>{formatName(dimension.OBJECT_NAME)}</CauseText>
        </CauseWrap>
        <SubText>
          <SubMetricText>{formatRootCause(rootcause)}</SubMetricText>
          <SubMetricText>{formatRootCauseValue(rootcause, metrics)} %</SubMetricText>
          <SubImpactedText>
            <Tooltip placement="bottomLeft" title={TOOLTIP_LABEL_IMPACTED_UNIQUE}>
              <ImpactedDeviceIco /> {formatImpactedUnique(metrics)}
            </Tooltip>
          </SubImpactedText>
        </SubText>
      </LeftDiv>
      <RightDiv>
        <span>{formatSessions(metrics)}</span>
        <SubText>Sessions</SubText>
      </RightDiv>
    </RowWrapper>
  );
}

export default Row;
